import {
  configureStore, EnhancedStore
} from '@reduxjs/toolkit';
import alertsRed, { StoreAlertsState } from './alertsSlice';

export const alertsReducer  = alertsRed;

export interface RootState {
  alerts: StoreAlertsState;
}

const _global = window;

export const getStore = (): EnhancedStore<RootState> => {
  if (_global._store) {
    return _global._store
  }

  _global._store = configureStore({
    reducer: {
      alerts: alertsReducer
    },
    devTools: {
      name: 'Plugandwork - toolkit'
    }
  })
  return _global._store
}

export default getStore;
